const selectors = {
  scrollButton: '[data-scroll-top]',
};

const scrollFunction = () => {
  if (document.body.scrollTop > 600 || document.documentElement.scrollTop > 600) {
    document.querySelector(selectors.scrollButton).style.display = 'block';
  } else {
    document.querySelector(selectors.scrollButton).style.display = 'none';
  }
};

const topFunction = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

/**
 * Initialize the controller
 */
const init = () => {
  window.onscroll = () => {
    scrollFunction();
  };
  document.querySelector(selectors.scrollButton).addEventListener('click', () => {
    topFunction();
  });
};

/**
 * Scroll Controller
 */
const scrollTopController = {
  init,
};

export default scrollTopController;
